import React, { useEffect, useState } from 'react'
import { getExtension } from 'src/util'

type Props = {
  url: string
  objectFit?: 'cover' | 'contain'
}
const Media: React.VFC<Props> = React.memo((props) => {
  const [url, setURL] = useState<string>('')
  const tmpExt = getExtension(props.url)
  useEffect(() => {
    setURL('')
    setTimeout(() => {
      setURL(props.url)
    }, 0)
  }, [props.url])
  if (!tmpExt) return <span>不明な拡張子</span>

  const ext = tmpExt.trim()
  const images = ['gif', 'jpeg', 'jpg', 'png']
  const movies = ['mp4']

  if (images.includes(ext)) {
    return (
      <img
        src={url}
        alt=""
        style={{ width: '100%', height: '100%', objectFit: props.objectFit }}
      />
    )
  } else if (movies.includes(ext)) {
    return (
      <video
        src={url}
        muted
        autoPlay
        playsInline
        loop
        style={{ width: '100%', height: '100%', objectFit: props.objectFit }}
      />
    )
  } else {
    return <span>不明な拡張子</span>
  }
})
Media.displayName = 'Media'

export default Media
